import React from 'react';
import { useTranslation } from 'react-i18next';
import { Container } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import AppCard from 'components/@common/Cards/AppCard';
import { AppLicenseStatus } from 'hooks/use-app-access';

export type Props = {
  apps: AppLicenseStatus[];
};

const AppCardContainer = ({ apps }: Props) => {
  const { t } = useTranslation('AppType');
  const classes = useStyles();

  return (
    <Container disableGutters maxWidth={false} className={classes.root}>
      {apps.map(({ pliManagedApp, status, dateExpiration }) => {
        const appProduct = pliManagedApp.appProduct?.product;
        const key = `app-${pliManagedApp.app.id}${appProduct ? `-${appProduct.id}` : ''}`;
        const type = pliManagedApp.type ? t(`${pliManagedApp.type}`) : t(`DEFAULT`);
        const href = `/app-access/${appProduct?.code ?? pliManagedApp.app.name}`;

        return (
          <AppCard
            key={key}
            href={href}
            src={pliManagedApp.accessDetails?.bannerUrl}
            title={pliManagedApp.title}
            subtitle={type}
            description={pliManagedApp.description}
            status={status}
            dateExpiration={dateExpiration}
          />
        );
      })}
    </Container>
  );
};

const useStyles = makeStyles(theme => ({
  root: {
    display: 'grid',
    gridGap: theme.spacing(3),
    gridTemplateColumns: `repeat(auto-fit, minmax(318px, 1fr))`,
    gridAutoFlow: 'dense',
    paddingBottom: theme.spacing(4),
    justifyItems: 'flex-start'
  }
}));

export default AppCardContainer;
